import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import last from 'lodash/last';
import Money from 'common/components/money';
import Thumbnail from 'common/components/thumbnail';

/**
 * Winner entry banner.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class WinnerBanner extends Component {
  componentDidMount() {
    const { fetchWinner, projectId } = this.props;
    fetchWinner(projectId);
  }

  render() {
    const { winner, project } = this.props;

    if (!winner) {
      return null;
    }

    const showThumb = !project.nda_required && !project.private_gallery;
    const revision = (winner.revisions || [])[0] || {};
    const thumbnails = revision.thumbnails || [];
    const isName = winner.entry_type === 'name';
    const thumbnailImage = isName? null : last(thumbnails);
    const creativeUrl = (
      winner.author_is_active && winner.author_allowed_to_participate?
      `/users/${winner.author_username}/` :
      ''
    );

    return (
      <div className="winner-entry">
        <div className="row">
          <div className={"columns align-middle small-16 large-" + (showThumb? "8":"16")}>
            <div className="winning-entry-text">
              <h2>{ project.client_username} picked a winning entry</h2>
              <h3>
                { project.client_username } offered <Money value={project.total_awards_and_tips} />
                {' '}in awards <br className="show-for-large"/> and received { project.entry_count }
                {' '}entries from { project.creative_count } creatives.<br />
                Congrats to <Link to={creativeUrl}>{ winner.author_username }</Link> for the winning
                entry!
              </h3>
              <p className="lead">
                The world&apos;s best entrepreneurs and small businesses <br className="show-for-large"/>trust crowdspring for their
                custom design {isName? 'and naming' : ''} needs.
              </p>
              <Link className="btn btn-primary" to="/how-it-works/">Find out more</Link>
            </div>
          </div>
          {showThumb &&
          <div className="columns show-for-large large-6 medium-offset-1">
            <Thumbnail className="tile entry-thumbnail read-only" image={thumbnailImage}>
              { isName && <div className="revision-name">{ revision.name }</div> }
              <div className="flag winner">
                <div>Winner</div>
              </div>
            </Thumbnail>
          </div>}
        </div>
      </div>
    );
  }
}

WinnerBanner.propTypes = {
  project: PropTypes.object.isRequired,
  projectId: PropTypes.number.isRequired,
  winner: PropTypes.object,
  fetchWinner: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./entries/components/winner_banner.jsx